import { render, staticRenderFns } from "./SelectColor.vue?vue&type=template&id=3809cab9&scoped=true&"
import script from "./SelectColor.vue?vue&type=script&lang=js&"
export * from "./SelectColor.vue?vue&type=script&lang=js&"
import style0 from "./SelectColor.vue?vue&type=style&index=0&id=3809cab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809cab9",
  null
  
)

export default component.exports